import {
    api, C, sampleFields, sampleInventory, sampleTreatments,
    FRUITETI_CROPS, OPEN_FIELD_CROP_GROUPS, WMO_CODES,
    PERMANENT_CROP_KEYWORDS, OFFLINE_QUEUE_KEY
} from './context.js';
import {
    ensureMapReady, refreshMapView, renderSavedFieldsOnMap, updateFieldFormPermissions
} from './map.js';
import {
    renderRecentTreatments, canTransmitSian, populateTreatmentFieldOptions,
    populateLogCropFilter, renderFullLogTable, renderInventoryTable,
    renderCarenzeCalendar, renderOperatorsList, populateSettingsCompanyFields,
    refreshSettingsView, refreshDashboardView
} from './activities.js';
export function initTabs() {
    const menuItems = document.querySelectorAll('.sidebar .menu-item');
    menuItems.forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const tabId = item.getAttribute('data-tab');
            
            // Verifica permessi per i tab ristretti
            if (C.currentUser) {
                const userRole = C.currentUser.role.toLowerCase();
                
                if (tabId === 'settings' && userRole !== 'admin') {
                    alert('L\'accesso a questa sezione è riservato all\'amministratore aziendale.');
                    return;
                }
                
                if (userRole === 'trattorista' && (tabId === 'treatment-log' || tabId === 'inventory')) {
                    alert('L\'accesso alla sezione "' + item.querySelector('span').textContent + '" è riservato agli operatori Fitosanitari.');
                    return;
                }
            }
            switchTab(tabId);
        });
    });

    const quickTreatmentBtn = document.getElementById('quick-treatment-btn');
    if (quickTreatmentBtn) {
        quickTreatmentBtn.addEventListener('click', () => {
            if (C.currentUser && C.currentUser.role.toLowerCase() === 'trattorista') {
                alert('La registrazione rapida dei trattamenti è riservata agli operatori Fitosanitari.');
                return;
            }
            switchTab('new-treatment');
        });
    }
}

export function switchTab(tabId) {
    // Update active class on menu items
    document.querySelectorAll('.sidebar .menu-item').forEach(item => {
        if (item.getAttribute('data-tab') === tabId) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });

    // Update active tab content
    document.querySelectorAll('.tab-content').forEach(tab => {
        if (tab.id === `tab-${tabId}` || tab.id === tabId) {
            tab.classList.add('active');
            tab.classList.remove('hidden');
            tab.style.setProperty('display', 'flex', 'important');
            tab.style.setProperty('opacity', '1', 'important');
            tab.style.setProperty('visibility', 'visible', 'important');
            console.log('[switchTab] SHOW tab:', tab.id, '| computed display:', window.getComputedStyle(tab).display, '| offsetHeight:', tab.offsetHeight);
        } else {
            tab.classList.remove('active');
            tab.classList.add('hidden');
            tab.style.setProperty('display', 'none', 'important');
        }
    });

    const mainContainer = document.querySelector('.main-content');
    if (mainContainer) mainContainer.scrollTop = 0;

    // Page title and subtitle updates
    const titleEl = document.getElementById('page-title');
    const subtitleEl = document.getElementById('page-subtitle');
    
    switch (tabId) {
        case 'dashboard':
            titleEl.textContent = 'Dashboard Aziendale';
            subtitleEl.textContent = 'Panoramica dello stato delle colture e dei trattamenti';
            refreshDashboardView();
            break;
        case 'fields-map':
            titleEl.textContent = 'Terreni e Mappa';
            subtitleEl.textContent = 'Appezzamenti, colture e confini dei tuoi campi';
            updateFieldFormPermissions();
            ensureMapReady();
            renderSavedFieldsOnMap();
            setTimeout(() => refreshMapView(), 50);
            setTimeout(() => refreshMapView(), 350);
            break;
        case 'new-treatment':
            titleEl.textContent = 'Nuovo Trattamento';
            subtitleEl.textContent = 'Registra un intervento fitosanitario o concimazione';
            populateTreatmentFieldOptions();
            break;
        case 'treatment-log':
            titleEl.textContent = 'Registro Attività di Campagna';
            subtitleEl.textContent = canTransmitSian()
                ? 'Tutte le operazioni (aratura, concimazione, trattamenti…), export QDCA e trasmissione SIAN'
                : 'Archivio completo delle attività agricole registrate sul quaderno';
            populateLogCropFilter();
            renderFullLogTable();
            break;
        case 'inventory':
            titleEl.textContent = 'Magazzino Fitosanitari';
            subtitleEl.textContent = 'Carico e scarico delle scorte di prodotti e concimi';
            renderInventoryTable();
            break;
        case 'carenze-calendar':
            titleEl.textContent = 'Calendario Carenze & Divieti di Rientro';
            subtitleEl.textContent = 'Quadro dei periodi di carenza e divieti di rientro in campo';
            renderCarenzeCalendar();
            break;
        case 'settings':
            titleEl.textContent = 'Impostazioni Azienda & Operatori';
            subtitleEl.textContent = 'Configura le credenziali SIAN e gestisci i profili dei tuoi operatori';
            refreshSettingsView();
            break;
    }
}
